// Google Analytics 配置
// 请替换为您的实际Google Analytics配置

export const GA_CONFIG = {
  // Google Analytics 4 (GA4) 测量ID
  // 格式: G-XXXXXXXXXX
  MEASUREMENT_ID: 'G-CCQ83GJKN4',
  
  // 是否启用调试模式
  DEBUG_MODE: process.env.NODE_ENV === 'development',
  
  // 是否启用自动页面跟踪
  AUTO_PAGE_TRACKING: true,
  
  // 是否启用自动事件跟踪
  AUTO_EVENT_TRACKING: true,
  
  // 自定义配置
  CUSTOM_CONFIG: {
    // 设置页面标题
    page_title: '颜色提取器',
    // 设置页面位置
    page_location: window.location.href,
    // 设置用户语言
    custom_map: {
      'language': 'user_language'
    }
  }
}

// 使用说明：
// 1. 访问 https://analytics.google.com/ 创建Google Analytics账号
// 2. 创建新的数据流（网站）
// 3. 获取测量ID（格式：G-XXXXXXXXXX）
// 4. 将上述配置中的 MEASUREMENT_ID 替换为您的实际测量ID
// 5. 根据需要调整其他配置选项

// 事件跟踪配置
export const GA_EVENTS = {
  // 页面访问事件
  PAGE_VIEW: 'page_view',
  
  // 用户反馈事件
  FEEDBACK_OPEN: 'feedback_open',
  FEEDBACK_SUBMIT: 'feedback_submit',
  FEEDBACK_SUCCESS: 'feedback_success',
  FEEDBACK_ERROR: 'feedback_error',
  
  // 图片处理事件
  IMAGE_UPLOAD: 'image_upload',
  IMAGE_EXTRACT_COLORS: 'image_extract_colors',
  IMAGE_DOWNLOAD: 'image_download',
  
  // 颜色管理事件
  COLOR_ADD: 'color_add',
  COLOR_DELETE: 'color_delete',
  COLOR_EXPORT: 'color_export',
  COLOR_IMPORT: 'color_import',
  
  // 语言切换事件
  LANGUAGE_SWITCH: 'language_switch',
  
  // 错误事件
  ERROR_OCCURRED: 'error_occurred'
}

// 自定义维度配置
export const GA_DIMENSIONS = {
  // 用户语言
  USER_LANGUAGE: 'user_language',
  // 图片类型
  IMAGE_TYPE: 'image_type',
  // 颜色数量
  COLOR_COUNT: 'color_count',
  // 网格大小
  GRID_SIZE: 'grid_size',
  // 用户评分
  USER_RATING: 'user_rating'
}
